import { clsx } from 'clsx'
import { type ComponentPropsWithRef, type ReactElement } from 'react'

import { type FlexProps, type PolymorphicElementProps, type TagName } from '../types'
import {
  crossAxisAlignmentToClassNameMap,
  gapToClassNameMap,
  mainAxisAlignmentToClassNameMap,
} from '../utils/layout'

export type ColumnProps = ComponentPropsWithRef<TagName> & FlexProps & PolymorphicElementProps

export function Column(props: ColumnProps): ReactElement {
  const {
    as = 'div',
    children,
    crossAxisAlignment,
    mainAxisAlignment,
    gap,
    wrap,
    className,
    ...rest
  } = props

  const Component = as

  return (
    <Component
      className={clsx(
        'display-column',
        crossAxisAlignment && crossAxisAlignmentToClassNameMap[crossAxisAlignment],
        mainAxisAlignment && mainAxisAlignmentToClassNameMap[mainAxisAlignment],
        gap && gapToClassNameMap[gap],
        wrap && 'flex-wrap',
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  )
}
